import { Component, Injector, OnInit } from '@angular/core';
import { ActiveModal } from '../../../modals/classes/active-modal';
import { CategoryEditForm } from '../../forms/category/edit.form';
import { CategoryModel } from '../../models/category.model';
import { CategoryService } from '../../services/category.service';
import { ChassisFormHandler } from '../../../forms/form/classes/form-handler';

@Component({
    selector: 'chassis-core-category-edit-modal',
    templateUrl: 'edit.modal.html',
    styleUrls: ['edit.modal.scss']
})
export class EditCategoryModal implements OnInit {

    public loading: any;

    /**
     * Title of the modal
     *
     * @type {string}
     */
    private title = 'Edit product category';

    /**
     * The ChassisFormHandler form instance.
     */
    public form: ChassisFormHandler;

    /**
     * The CategoryModel instance.
     */
    protected model: CategoryModel;

    constructor(
        protected modal: ActiveModal,
        protected injector: Injector,
        protected categoryService: CategoryService,
    ) {
    }

    ngOnInit() {
        this.createForm();
        this.setDeleteModalButton();
        this.loading = this.modal.get('loading');
    }

    /**
     * Create the form.
     */
    protected createForm() {
        this.model = this.modal.get<CategoryModel>('category');

        this.form = new ChassisFormHandler(this.injector, CategoryEditForm, this.model);
    }

    protected setDeleteModalButton() {
        const buttons = this.modal.get<any>('buttons');

        buttons.after('close', 'delete', {
            text: 'Delete',
            classes: 'btn-danger',
            callback: () => {
                this.loading.start();
                this.modal.dismiss('delete');
            }
        });
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/categories/modals/edit/edit.modal.ts